/**
 * HYLA Advantages by Notch — modal playback helper.
 * Theme ModalDialog.show() calls pauseAllMedia() after loading deferred media,
 * which would pause Shopify/HTML5 video and already-loaded embeds on reopen.
 * This script resumes playback when the modal opens and resets on close.
 */
(function () {
  function postYouTube(iframe, func) {
    if (!iframe || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage(
      JSON.stringify({ event: 'command', func: func, args: '' }),
      '*'
    );
  }

  function postVimeo(iframe, method) {
    if (!iframe || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage(JSON.stringify({ method: method }), '*');
  }

  function playMedia(modal) {
    const video = modal.querySelector('video');
    const yt = modal.querySelector('iframe.js-youtube');
    const vimeo = modal.querySelector('iframe.js-vimeo');

    if (video) {
      video.playsInline = true;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    if (yt) postYouTube(yt, 'playVideo');
    if (vimeo) postVimeo(vimeo, 'play');
  }

  function stopMedia(modal) {
    const video = modal.querySelector('video');
    const yt = modal.querySelector('iframe.js-youtube');
    const vimeo = modal.querySelector('iframe.js-vimeo');

    if (video) {
      video.pause();
      try {
        video.currentTime = 0;
      } catch (e) {}
    }

    if (yt) postYouTube(yt, 'pauseVideo');
    if (vimeo) postVimeo(vimeo, 'pause');
  }

  function bindModal(modal) {
    if (modal.dataset.hanBound === 'true') return;
    modal.dataset.hanBound = 'true';

    const observer = new MutationObserver(function () {
      if (modal.hasAttribute('open')) {
        // After ModalDialog.show() → loadContent() → pauseAllMedia()
        window.setTimeout(function () {
          playMedia(modal);
        }, 60);
      } else {
        stopMedia(modal);
      }
    });

    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  function init() {
    document.querySelectorAll('modal-dialog.han__modal').forEach(bindModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
